import MembershipConcernFormContainer from './MembershipConcernFormContainer';

export default MembershipConcernFormContainer;
